<div
  class="select select--{{ view }}"
  [ngClass]="{ 'select--disabled': readonly || disabled }"
>
  <div class="select__color--{{ color }}">
    <ng-container *ngIf="label">
      <label
        class="select__label"
        (click)="onClickSelect(!this.showOptions)"
      >{{ label }}{{required ? '*' : ''}}</label>
    </ng-container>
    <div
      class="select__control"
      [ngClass]="{
        'select__control--open': showOptions,
        'select__control--success': success,
        'select__control--error': error
      }"
    >
      <div
        class="select__selected"
        (click)="onClickSelect(!this.showOptions)"
      >
        <span
          class="selected__label"
          [ngClass]="{ 'selected__label--selected': selectValue, 'selected__label--inactive': selectValue?.inactive }"
        >{{ selectValue?.key || placeholder }}</span>
        <img
          class="selected__icon"
          alt="Select arrow icon"
          mfpLazyImage
          lazySrc="assets/icons/arrow-small.svg"
          [ngClass]="{ 'selected__icon--open': showOptions }"
        />
      </div>
      <ng-container *ngIf="showOptions">
        <ul class="select__options">
          <li
            *ngFor="let option of innerOptions"
            class="select__option"
            [ngClass]="{'select__option--inactive': option.inactive}"
            (click)="selectOption(option)"
          >{{ option.key }}</li>
        </ul>
      </ng-container>
    </div>
    <ng-container *ngIf="helper">
      <p class="select__helper">{{ helper }}</p>
    </ng-container>
  </div>
</div>
